<!-- ChoiceTableCell.vue -->
<script setup lang="ts">
    import '../../../css/choice.css';
    import { ICol, FormattedValueStr, RenderModeType, GetCellTooltip } from '../../lib/ChoiceTableHelpers';
    import { TableRowType, IconTypes, DisplayStyle } from '../../Enums/UiEnums'
    import Icon from '../Icon.vue';
    import { computed } from 'vue';

    const props = defineProps<{
        col: ICol,
        row: Record<string, any>,
        checkboxScaleStyle?: string
    }>();

    const emits = defineEmits<{
        onChange: [col: ICol, row: Record<string, any>]
    }>();

    const formattedValueStr = computed(() => FormattedValueStr(props.col, props.row, TableRowType.Body ));
    const tooltip = computed(() => GetCellTooltip(props.col, props.row));

</script>
<template>
    <template v-if="RenderModeType.Selection === col.RenderMode">
        <input type="checkbox" 
                v-model="row[col.DataField]" 
                @change="() => emits('onChange', col, row)"
                v-if="col.DataField" 
                :style="checkboxScaleStyle" 
                class="ms-1"
                :title="tooltip"/>
    </template>
    <template v-else-if="RenderModeType.HTML === col.RenderMode && col.DataField">
        <span v-html="row[col.DataField]" :title="tooltip"/>
    </template>
    <template v-else-if="RenderModeType.BoolYesNo === col.RenderMode">
        <Icon :icon="IconTypes.CheckMark" v-if="'Yes' === formattedValueStr" :displayStyle="DisplayStyle.Success"/>
        <Icon :icon="IconTypes.XMark" v-if="'No' === formattedValueStr" :displayStyle="DisplayStyle.Danger"/>
        <span :title="tooltip">{{ formattedValueStr }}</span>
    </template>
    <template v-else-if="RenderModeType.Clickable === col.RenderMode">
        <span class="isalus-link" :title="tooltip">{{ formattedValueStr }}</span>
    </template>
    <template v-else>
        <span :title="tooltip">{{ formattedValueStr }}</span>
    </template>
</template>